import { TimerExtras } from "../../lib/timer";
import { AttemptId, ItemId, ProductId, QuizId } from "../datasource";
import { ItemModel, NullItemModel } from "./item";
import { ListModel, NullListModel } from "./list";
import { MetadataModel, NullMetadataModel } from "./metadata";
import { NullScoreModel, ScoreModel } from "./score";
import { NullSettingsModel, SettingsModel } from "./settings";
import { NullStateModel, StateModel } from "./state";
import { AttemptState, GlobalState } from "../datasource/state";

interface ModelProps<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId, E extends TimerExtras> {
	metadata?: MetadataModel<P, A>;
	list?: ListModel<I>;
	item?: ItemModel<P, A, I, E>;
	score?: ScoreModel<A, Z>;
	settings?: SettingsModel<P>;
	state?: {
		global: StateModel<GlobalState>;
		attempt: StateModel<AttemptState>;
	};
}

export default class Model<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId, E extends TimerExtras> {
	metadata: MetadataModel<P, A>;
	list: ListModel<I>;
	item: ItemModel<P, A, I, E>;
	score: ScoreModel<A, Z>;
	settings: SettingsModel<P>;
	state: {
		global: StateModel<GlobalState>;
		attempt: StateModel<AttemptState>;
	};

	constructor({metadata, list, item, score, settings, state}: ModelProps<P, A, Z, I, E>) {
		this.metadata = metadata ?? new NullMetadataModel();
		this.list = list ?? new NullListModel();
		this.item = item ?? new NullItemModel();
		this.score = score ?? new NullScoreModel();
		this.settings = settings ?? new NullSettingsModel();
		this.state = state ?? {
			global: new NullStateModel<GlobalState>(),
			attempt: new NullStateModel<AttemptState>(),
		};
	}

	static retryPromise<T>(promiseFunction: () => Promise<T>, catchHandler?: () => void, retries: number = 3): Promise<T> {
		return retries > 0 ? promiseFunction().catch(error => {
			catchHandler && catchHandler();
			return Promise.resolve(this.retryPromise(promiseFunction, catchHandler, retries - 1));
		}) : Promise.reject();
	}
}